var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0588 15.8449L12.7602 11.1337C12.7546 11.1387 11.3801 12.34 11.3165 12.3924C9.74738 13.7493 4.15826 7.56247 5.6682 6.14549L7.12389 4.8707L2.84306 0.1358L1.37165 1.42601C-3.61671 6.00072 10.3781 21.4291 15.5829 17.1311C15.6684 17.0608 17.0532 15.8498 17.0588 15.8449Z",
    fill: "#63C0DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.69679868a96150e0dcde7b32a466e380.svg";
export { ForwardRef as ReactComponent };